import list from './data'
export default{
  name:'slideshow',
  data(){
    return {
      list:list,
      currentList:list.slice(0,2),
      currentIndex: Math.floor(Math.random() * (list.length - 1 - 0 + 1) + 0),
      speed:10,
    }
  },
  mounted() {
    this.autoScroll()
  },
  methods: {
    autoScroll(){
      setInterval(() => {
        const len = this.list.length;
        this.currentIndex = (this.currentIndex+1)%len;
        this.currentList=this.list.slice(this.currentIndex,this.currentIndex+2)
      }, 2800);
    }
  },
}